// extracted by mini-css-extract-plugin
export default {"project-setting":"projectSetting_project-setting__ab7WR"};